import React from 'react';
import { useTranslation } from 'react-i18next';
import { Table, Typography, Row, Col, ConfigProvider } from '@app/ui';
import './SocialBenchmarking.scss';
import HighlightsRankContainer from './HighlightsRankContainer';
import { abbreviatedDecimal } from '@app/utils/formatters';

const { Title } = Typography;

const HighlightsRank = ({ highlights }: { highlights: any }) => {
    const { t } = useTranslation('benchmarking');
    if (!highlights || !highlights.top || !highlights.bottom) {
        return null;
    }

    const top3Data =
        highlights.top?.map((top: any) => ({
            key: top.accountGroupId,
            ranking: top.rank,
            team: top.accountGroupName,
            itemCount: top.itemCount,
        })) || [];

    const bottom3Data =
        highlights.bottom?.map((bottom: any) => ({
            key: bottom.accountGroupId,
            ranking: bottom.rank,
            team: bottom.accountGroupName,
            itemCount: bottom.itemCount,
        })) || [];

    const columns = [
        {
            title: t('socialBenchmarking.ranking.columnTitle'),
            dataIndex: 'team',
            key: 'team',
            render: (text: string, record: any) => (
                <span>
                    {record.ranking}. {text} (
                    {abbreviatedDecimal(
                        record.itemCount,
                        record.itemCount >= 1000,
                    )}
                    )
                </span>
            ),
        },
    ];

    return (
        <HighlightsRankContainer>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <Title level={5} style={{ marginBottom: 8 }}>
                        {t('socialBenchmarking.ranking.top3')}
                    </Title>
                    <ConfigProvider
                        theme={{
                            components: {
                                Table: {
                                    borderColor: '#CCCCCC',
                                    headerBg: '#E3EBEE',
                                    headerColor: '#1B1C1D',
                                },
                            },
                        }}
                    >
                        <Table
                            dataSource={top3Data}
                            columns={columns}
                            pagination={false}
                            showHeader
                            size="small"
                            style={{
                                backgroundColor: '#fff',
                            }}
                            bordered
                        />
                    </ConfigProvider>
                </Col>
                <Col span={12}>
                    <Title level={5} style={{ marginBottom: 8 }}>
                        {t('socialBenchmarking.ranking.bottom3')}
                    </Title>
                    <ConfigProvider
                        theme={{
                            components: {
                                Table: {
                                    borderColor: '#CCCCCC',
                                    headerBg: '#E3EBEE',
                                    headerColor: '#1B1C1D',
                                },
                            },
                        }}
                    >
                        <Table
                            dataSource={bottom3Data}
                            columns={columns}
                            pagination={false}
                            showHeader
                            size="small"
                            style={{
                                backgroundColor: '#fff',
                            }}
                            bordered
                        />
                    </ConfigProvider>
                </Col>
            </Row>
        </HighlightsRankContainer>
    );
};

export default HighlightsRank;
